import LAZY_LOAD_MENU_SIZE from 'bento-ordering/menus/constants/lazyLoadMenuSettings';

const _menuLookup = {};
/**
 * returns the number of items in a menu section
 * @private
 * @param {Object} menuSection
 * @param {[]} menuSection.items
 *
 * @return {number}
 */
const _getMenuSectionLength = menuSection => menuSection.items.length;

/**
 * returns the number of items in a menu
 * @private
 * @param {Object} menu
 * @param {[]} menu.sections
 *
 * @return {number}
 */
const _getMenuLength = menu =>
  menu.sections.reduce((acc, curr) => {
    return acc + _getMenuSectionLength(curr);
  }, 0);

/**
 * determines whether to lazy load menu based on the number of items in the menu
 * can change LAZY_LOAD_MENU_SIZE to configure the size at which menu should lazy load
 * @param {Object} menu
 * @param {number} menu.id
 * @return {boolean}
 */
const shouldLazyLoadMenu = menu => {
  const { id } = menu;
  if (!_menuLookup.hasOwnProperty(id)) {
    _menuLookup[id] = _getMenuLength(menu) >= LAZY_LOAD_MENU_SIZE;
  }
  return _menuLookup[id];
};

export default shouldLazyLoadMenu;
